<template>
  <st-modal class="st-reset-password-sms-modal" @esc-close="close" v-if="open">
    <template v-slot:header>
      <div class="st-reset-password-sms-modal__header st-modal-header">
        <h3>Återställ lösenord</h3>
      </div>
    </template>

    <template v-slot:body>
      <div class="st-reset-password-sms-modal__body st-modal-body">
        <span class="st-reset-password-sms-modal__body__text"
          >Om ditt nummer finns i systemet så kommer ett sms med en
          verifieringskod att skickas till detta nummer.</span
        >
        <span class="st-reset-password-sms-modal__body__text"
          >OBS Har du redan efterfrågat ett nytt lösenord men inte fått något?
          Vänta 15 minuter innan du försöker igen.</span
        >

        <st-form-group
          id="token"
          label="Ange verifieringskod"
          required
          :validation="$v.token"
          :validation-errors="validationErrors.token"
        >
          <st-input
            tabindex="0"
            type="text"
            id="token"
            v-model="token"
            :keydown-enter="submit"
            :placeholder="'Ange verifieringskod'"
            required
            :blur="$v.token.$touch"
            :invalid="$v.token.$error"
          />
        </st-form-group>
      </div>
    </template>

    <template v-slot:footer>
      <div class="st-reset-password-sms-modal__footer">
        <div class="st-reset-password-sms-modal__footer__actions">
          <st-button
            :id="'submit'"
            @click="submit"
            primary
            tabindex="0"
            @keydown.tab.native="onTab"
            >Skicka</st-button
          >
        </div>
      </div>
    </template>
  </st-modal>
</template>

<script>
import {
  StButton,
  StModal,
  StFormGroup,
  StInput,
} from "skanetrafiken/dist/legacy";
import ForgotPasswordSmsValidations from "../validators/forgot-password-sms-validations";
import ForgotPasswordSmsValidationErrors from "../validators/forgot-password-sms-validation-errors";
import {
  shiftTabToLastElement,
  tabToFirstElement,
} from "@/modules/login-form/helpers/modalTabHelper";

export default {
  name: "st-reset-password-sms-modal-modal",
  props: {
    close: {
      type: Function,
    },
    open: {
      type: Boolean,
    },
  },
  components: {
    StButton,
    StModal,
    StFormGroup,
    StInput,
  },
  data() {
    return {
      token: "",
      validationErrors: ForgotPasswordSmsValidationErrors,
    };
  },
  validations: {
    ...ForgotPasswordSmsValidations,
  },
  methods: {
    submit() {
      this.$v.$touch();
      if (this.$v.$invalid) {
        document.querySelector("#token").focus();
        return;
      }
      // Re-directing to mitt-konto's form for resetting password with token user-input
      window.location.href = `/mitt-konto/#/aterstall-losenord?rt=${this.token}`;
      this.close(true); // sending in 'true' as param to show that it is auto-closed and not closed by a user.
    },
    onTab(e) {
      if (e.shiftKey) {
        shiftTabToLastElement(e, "submit");
      } else {
        tabToFirstElement(e, "token");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~skanetrafiken/dist/scss/main.scss";

.st-reset-password-sms-modal {
  font-family: $source-sans-pro;
  color: $dark-grey;
  font-size: rem-calc(16);
  &__body {
    font-family: $source-sans-pro;
    color: $dark-grey;
    line-height: rem-calc(20);
    & > :first-child {
      margin-bottom: rem-calc(10);
    }
    &__text {
      display: block;
    }
  }
  &__footer {
    margin-top: rem-calc(20);
    &__actions {
      display: flex;
      flex: 1;
      & > .st-button {
        &:first-child {
          margin-right: rem-calc(8);
        }
        flex: 1;
      }
    }
  }
}
</style>
